// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__bb3197cf35753dc6fa92","cls2":"SimplePaperPodcast-cls2___eafa48f03e34bc93596 SimplePaperPodcast-cls1__bb3197cf35753dc6fa92"};